import { render, staticRenderFns } from "./SortableTable.vue?vue&type=template&id=262ede72&scoped=true"
import script from "./SortableTable.vue?vue&type=script&lang=ts"
export * from "./SortableTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262ede72",
  null
  
)

export default component.exports